var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.5C2.5 4.614 2.5 3.672 3.086 3.086C3.672 2.5 4.614 2.5 6.5 2.5C8.386 2.5 9.328 2.5 9.914 3.086C10.5 3.672 10.5 4.614 10.5 6.5C10.5 8.386 10.5 9.328 9.914 9.914C9.328 10.5 8.386 10.5 6.5 10.5C4.614 10.5 3.672 10.5 3.086 9.914C2.5 9.328 2.5 8.386 2.5 6.5ZM13.5 17.5C13.5 15.614 13.5 14.672 14.086 14.086C14.672 13.5 15.614 13.5 17.5 13.5C19.386 13.5 20.328 13.5 20.914 14.086C21.5 14.672 21.5 15.614 21.5 17.5C21.5 19.386 21.5 20.328 20.914 20.914C20.328 21.5 19.386 21.5 17.5 21.5C15.614 21.5 14.672 21.5 14.086 20.914C13.5 20.328 13.5 19.386 13.5 17.5ZM2.5 17.5C2.5 15.614 2.5 14.672 3.086 14.086C3.672 13.5 4.614 13.5 6.5 13.5C8.386 13.5 9.328 13.5 9.914 14.086C10.5 14.672 10.5 15.614 10.5 17.5C10.5 19.386 10.5 20.328 9.914 20.914C9.328 21.5 8.386 21.5 6.5 21.5C4.614 21.5 3.672 21.5 3.086 20.914C2.5 20.328 2.5 19.386 2.5 17.5ZM13.5 6.5C13.5 4.614 13.5 3.672 14.086 3.086C14.672 2.5 15.614 2.5 17.5 2.5C19.386 2.5 20.328 2.5 20.914 3.086C21.5 3.672 21.5 4.614 21.5 6.5C21.5 8.386 21.5 9.328 20.914 9.914C20.328 10.5 19.386 10.5 17.5 10.5C15.614 10.5 14.672 10.5 14.086 9.914C13.5 9.328 13.5 8.386 13.5 6.5Z",
    stroke: "#5B595C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard2);
export default __webpack_public_path__ + "static/media/dashboard2.e2a753cc8beac9e497e4228a768b2f05.svg";
export { ForwardRef as ReactComponent };